import styled from 'styled-components/macro';

export const SidebarClosedContainerDiv = styled.div`
  margin-top: 50px;
`;
